import type { SystemStyles } from '@byecode/ui/theme/types'
import { filter, isNil } from 'rambda'

import type { AnyRecord } from '../../types'

export function extractSystemStyles<T extends AnyRecord>(props: SystemStyles & T) {
    const { m, mb, ml, mr, mt, mx, my, p, pb, pl, pr, pt, px, py, ...rest } = props

    const systemStyles: SystemStyles = filter(v => !isNil(v), {
        m,
        mb,
        ml,
        mr,
        mt,
        mx,
        my,
        p,
        pb,
        pl,
        pr,
        pt,
        px,
        py
    })

    return { systemStyles, rest: rest as T }
}
